var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"alert no-mobile",class:_vm.obj.type},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.obj.msg)}}),_c('i',{staticClass:"mdi mdi-close",on:{"click":function($event){_vm.show = false}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }